









































import { Component, Prop, Vue } from 'vue-property-decorator';
import { TokenUser } from '@/TokenUser'
import { Account, PlayerCS } from '@/Account'
import ModalWrapperComponent from '@/components/ModalWrapperComponent.vue';           // @ is an alias to /src
import AccountUsernameComponent from '@/components/AccountUsernameComponent.vue';                       // @ is an alias to /src
import { LeaderboardEntryForClient } from '@/Leaderboard';

@Component({
  name: 'LeaderboardLockedPlayerList',
  components: { ModalWrapperComponent, AccountUsernameComponent }
})
export default class LeaderboardLockedPlayerListComponent extends Vue {
  // prop reactive member variables publically available to the html template
  @Prop({ default: null })
  public lefc: LeaderboardEntryForClient

  @Prop({ default: 0 })
  public index: number                 // in case it's ever useful for us to know where we are in the main list

  @Prop()
  public playerID: number

  @Prop()
  public playerName: string

  @Prop()
  public isTiedWithPreviousIndex: boolean


  // public reactive member variables available to the html template

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get user(): TokenUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }

  public clickedName(flowAddress: string) {
    const url: string = Account.getPortfolioLink(flowAddress)
    if (url) window.open(url, "_blank"); 
  }

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted() with index = ${this.index}`)
  }

  private async beforeDestroy() { 
    if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy() with index = ${this.index}`)
  }

}
